import React from 'react';
import styles from './index.module.scss';
import { analyticsApi } from '../../../services/analytics';

type Props = {
  key: string;
  value: string;
  id: string;
  trackId: string;
};

const EmptyMealGroup = (props: Props) => {
  return (
    <a href={`/tracker/${props.trackId}/group/${props.id}/meal`}
       className={styles.wrapper}
       onClick={() => analyticsApi.logEvent(
         '',
         'Action',
         { meal: props.value },
         'Add Product Clicked'
       )}
    >
        <div>{props.value}</div>
        <div>
          <img src="/assets/images/plus.svg" alt="" />
        </div>
    </a>
  );
};

export default EmptyMealGroup;
